import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-video-appointment-launch-unavailable',
  imports: [MatIcon],
  templateUrl: './video-appointment-launch-unavailable.component.html',
  styleUrl: './video-appointment-launch-unavailable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoAppointmentLaunchUnavailableComponent {}
